var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createContext, useContext, useEffect, useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { CountryCode, } from '../../types';
import { createLoadFn } from '../Form/utils';
export var ufoVehicleDetailsFormContextDataDefaultValue = {
    countryCode: CountryCode.US,
    values: {
        years: [],
        makes: [],
        models: [],
        options: [],
        tireSizes: [],
        states: [],
        customTireSizeSizes: [],
        customTireSizeAspectRatios: [],
        customTireSizeDiameters: [],
        customTireSizeLoads: [],
        customTireSizeSpeedRatings: [],
    },
    load: {
        years: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        makes: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        models: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        options: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        tireSizes: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        loadOnlyCustomOptionTireSize: function () { },
        states: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        customTireSizeSizes: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        customTireSizeAspectRatios: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        customTireSizeDiameters: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        customTireSizeLoads: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
        customTireSizeSpeedRatings: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); }); },
    },
    loading: {
        years: false,
        makes: false,
        models: false,
        options: false,
        tireSizes: false,
        states: false,
        customTireSizeSizes: false,
        customTireSizeAspectRatios: false,
        customTireSizeDiameters: false,
        customTireSizeLoads: false,
        customTireSizeSpeedRatings: false,
    },
};
export var UFOVehicleDetailsFormContext = createContext(ufoVehicleDetailsFormContextDataDefaultValue);
export var useUFOVehicleDetailsFormContextValue = function (params) {
    var countryCode = params.countryCode, fetchYears = params.fetchYears, fetchMakes = params.fetchMakes, fetchModels = params.fetchModels, fetchOptions = params.fetchOptions, fetchTireSizes = params.fetchTireSizes, fetchStates = params.fetchStates, fetchCustomTireSizeSizes = params.fetchCustomTireSizeSizes, fetchCustomTireSizeAspectRatios = params.fetchCustomTireSizeAspectRatios, fetchCustomTireSizeDiameters = params.fetchCustomTireSizeDiameters, fetchCustomTireSizeLoads = params.fetchCustomTireSizeLoads, fetchCustomTireSizeSpeedRatings = params.fetchCustomTireSizeSpeedRatings;
    var _a = useState([]), years = _a[0], setYears = _a[1];
    var _b = useState([]), makes = _b[0], setMakes = _b[1];
    var _c = useState([]), models = _c[0], setModels = _c[1];
    var _d = useState([]), options = _d[0], setOptions = _d[1];
    var _e = useState([]), tireSizes = _e[0], setTireSizes = _e[1];
    var _f = useState([]), states = _f[0], setStates = _f[1];
    var _g = useState([]), customTireSizeSizes = _g[0], setCustomTireSizeSizes = _g[1];
    var _h = useState([]), customTireSizeAspectRatios = _h[0], setCustomTireSizeAspectRatios = _h[1];
    var _j = useState([]), customTireSizeDiameters = _j[0], setCustomTireSizeDiameters = _j[1];
    var _k = useState([]), customTireSizeLoads = _k[0], setCustomTireSizeLoads = _k[1];
    var _l = useState([]), customTireSizeSpeedRatings = _l[0], setCustomTireSizeSpeedRatings = _l[1];
    var _m = useState(false), loadingYears = _m[0], setLoadingYears = _m[1];
    var _o = useState(false), loadingMakes = _o[0], setLoadingMakes = _o[1];
    var _p = useState(false), loadingModels = _p[0], setLoadingModels = _p[1];
    var _q = useState(false), loadingOptions = _q[0], setLoadingOptions = _q[1];
    var _r = useState(false), loadingTireSizes = _r[0], setLoadingTireSizes = _r[1];
    var _s = useState(false), loadingStates = _s[0], setLoadingStates = _s[1];
    var _t = useState(false), loadingCustomTireSizeSizes = _t[0], setLoadingCustomTireSizeSizes = _t[1];
    var _u = useState(false), loadingCustomTireSizeAspectRatios = _u[0], setLoadingCustomTireSizeAspectRatios = _u[1];
    var _v = useState(false), loadingCustomTireSizeDiameters = _v[0], setLoadingCustomTireSizeDiameters = _v[1];
    var _w = useState(false), loadingCustomTireSizeLoads = _w[0], setLoadingCustomTireSizeLoads = _w[1];
    var _x = useState(false), loadingCustomTireSizeSpeedRatings = _x[0], setLoadingCustomTireSizeSpeedRatings = _x[1];
    var countryParam = {
        country_code: countryCode !== null && countryCode !== void 0 ? countryCode : CountryCode.US,
    };
    var loadYears = createLoadFn(fetchYears, setYears, setLoadingYears, countryParam);
    var loadMakes = createLoadFn(fetchMakes, setMakes, setLoadingMakes, countryParam, true, 'make'); // Optional Make
    var loadModels = createLoadFn(fetchModels, setModels, setLoadingModels, countryParam, true, 'model'); // Optional Model
    var loadOptions = createLoadFn(fetchOptions, setOptions, setLoadingOptions, countryParam, true, 'option'); // Optional Option
    var loadTireSizes = createLoadFn(fetchTireSizes, setTireSizes, setLoadingTireSizes, countryParam, true, 'tireSize'); // Optional TireSize
    var loadStates = createLoadFn(fetchStates, setStates, setLoadingStates, countryParam);
    var loadCustomTireSizeSizes = createLoadFn(fetchCustomTireSizeSizes, setCustomTireSizeSizes, setLoadingCustomTireSizeSizes, countryParam);
    var loadCustomTireSizeAspectRatios = createLoadFn(fetchCustomTireSizeAspectRatios, setCustomTireSizeAspectRatios, setLoadingCustomTireSizeAspectRatios, countryParam);
    var loadCustomTireSizeDiameters = createLoadFn(fetchCustomTireSizeDiameters, setCustomTireSizeDiameters, setLoadingCustomTireSizeDiameters, countryParam);
    var loadCustomTireSizeLoads = createLoadFn(fetchCustomTireSizeLoads, setCustomTireSizeLoads, setLoadingCustomTireSizeLoads, countryParam);
    var loadCustomTireSizeSpeedRatings = createLoadFn(fetchCustomTireSizeSpeedRatings, setCustomTireSizeSpeedRatings, setLoadingCustomTireSizeSpeedRatings, countryParam);
    var loadOnlyCustomOptionTireSize = function () { return setTireSizes([{
            value: 'custom',
            label: 'Custom Tire Size',
        }, {
            value: 'unknown',
            label: '- Unknown Tire Size -',
        }]); };
    useEffect(function () {
        loadYears(countryParam);
        loadStates(countryParam);
    }, []);
    var t = useTranslation().t;
    var translateSelectOptions = (function (selectOptions) { return selectOptions.map(function (opt) { return (__assign(__assign({}, opt), { label: t(opt.label) })); }); });
    return {
        countryCode: countryCode,
        values: {
            years: years,
            makes: makes,
            models: translateSelectOptions(models),
            options: translateSelectOptions(options),
            tireSizes: translateSelectOptions(tireSizes),
            states: states,
            customTireSizeSizes: customTireSizeSizes,
            customTireSizeAspectRatios: customTireSizeAspectRatios,
            customTireSizeDiameters: customTireSizeDiameters,
            customTireSizeLoads: customTireSizeLoads,
            customTireSizeSpeedRatings: customTireSizeSpeedRatings,
        },
        load: {
            years: loadYears,
            makes: loadMakes,
            models: loadModels,
            options: loadOptions,
            tireSizes: loadTireSizes,
            states: loadStates,
            loadOnlyCustomOptionTireSize: loadOnlyCustomOptionTireSize,
            customTireSizeSizes: loadCustomTireSizeSizes,
            customTireSizeAspectRatios: loadCustomTireSizeAspectRatios,
            customTireSizeDiameters: loadCustomTireSizeDiameters,
            customTireSizeLoads: loadCustomTireSizeLoads,
            customTireSizeSpeedRatings: loadCustomTireSizeSpeedRatings,
        },
        loading: {
            years: loadingYears,
            makes: loadingMakes,
            models: loadingModels,
            options: loadingOptions,
            tireSizes: loadingTireSizes,
            states: loadingStates,
            customTireSizeSizes: loadingCustomTireSizeSizes,
            customTireSizeAspectRatios: loadingCustomTireSizeAspectRatios,
            customTireSizeDiameters: loadingCustomTireSizeDiameters,
            customTireSizeLoads: loadingCustomTireSizeLoads,
            customTireSizeSpeedRatings: loadingCustomTireSizeSpeedRatings,
        },
    };
};
export var useUFOVehicleDetailsFormContext = function () {
    var ufoVehicleDetailsFormContext = useContext(UFOVehicleDetailsFormContext);
    if (!ufoVehicleDetailsFormContext) {
        throw new Error('useUFOVehicleDetailsFormContext must be used within UFOVehicleDetailsFormContext.Provider');
    }
    return ufoVehicleDetailsFormContext;
};
//# sourceMappingURL=UFOVehicleDetailsFormContext.js.map